// https://github.com/lizheming/iput
import React from 'react'
import './IPut.less'

/**
 * Function to get cursor position
 */
function getRange(el) {
  let cuRange
  let tbRange
  let headRange
  let range
  let dupRange
  const ret = {}

  if (el.setSelectionRange) {
    // standard
    // @ts-expect-error 9/11/2020
    ret.begin = el.selectionStart
    // @ts-expect-error 9/11/2020
    ret.end = el.selectionEnd
    // @ts-expect-error 9/11/2020
    ret.result = el.value.substring(ret.begin, ret.end)
    // @ts-expect-error 9/11/2020
  } else if (document.selection) {
    // ie
    if (el.tagName.toLowerCase() === 'input') {
      // @ts-expect-error 9/11/2020
      cuRange = document.selection.createRange()
      tbRange = el.createTextRange()
      tbRange.collapse(true)
      tbRange.select()
      // @ts-expect-error 9/11/2020
      headRange = document.selection.createRange()
      headRange.setEndPoint('EndToEnd', cuRange)
      // @ts-expect-error 9/11/2020
      ret.begin = headRange.text.length - cuRange.text.length
      // @ts-expect-error 9/11/2020
      ret.end = headRange.text.length
      // @ts-expect-error 9/11/2020
      ret.result = cuRange.text
      cuRange.select()
    } else if (el.tagName.toLowerCase() === 'textarea') {
      // @ts-expect-error 9/11/2020
      range = document.selection.createRange()
      dupRange = range.duplicate()
      dupRange.moveToElementText(el)
      dupRange.setEndPoint('EndToEnd', range)
      // @ts-expect-error 9/11/2020
      ret.begin = dupRange.text.length - range.text.length
      // @ts-expect-error 9/11/2020
      ret.end = dupRange.text.length
      // @ts-expect-error 9/11/2020
      ret.result = range.text
    }
  }
  el.focus()
  return ret
}
// TODO use the component from NPM and remove this from our codebase DEV-2235
class IPut extends React.Component {
  /**
   * set default props
   */
  static defaultProps = {
    className: '',
    isError: () => false,
    onChange: () => {}
  }
  /**
   * default state value
   */
  state = {
    value: []
  }
  componentDidMount() {
    // @ts-expect-error 9/11/2020
    const parts = Array.isArray(this.props.defaultValue)
      ? // @ts-expect-error 9/11/2020
        this.props.defaultValue
      : // @ts-expect-error 9/11/2020
        this.props.defaultValue.split('.')

    this.setState({
      value: parts.concat(['0', '0', '0', '0']).filter(Boolean).slice(0, 4)
    })
  }
  /**
   * Change Event
   */
  handleChange(e, i) {
    let val = Number(e.target.value)
    if (isNaN(e.target.value)) {
      return e.preventDefault()
    }
    // @ts-expect-error 9/11/2020
    if (val !== '' && (val > 255 || val < 0)) {
      val = 255
    }

    const value = this.state.value
    // @ts-expect-error 9/11/2020
    value[i] = val
    this.setState({ value }, () => this.onPropsChange())

    if (!isNaN(val) && String(val).length === 3 && i < 3) {
      this[`_input-${i + 1}`].focus()
    }
  }
  /**
   * Keydown Event
   */
  handleKeyDown(e, i) {
    /* 37 = ←, 39 = →, 8 = backspace */
    let domId = i
    if (
      (e.keyCode === 37 || e.keyCode === 8) &&
      // @ts-expect-error 9/11/2020
      getRange(e.target).end === 0 &&
      i > 0
    ) {
      domId = i - 1
    }
    if (
      e.keyCode === 39 &&
      // @ts-expect-error 9/11/2020
      getRange(e.target).end === e.target.value.length &&
      i < 3
    ) {
      domId = i + 1
    }
    this[`_input-${domId}`].focus()
  }
  /**
   * Paste Event
   */
  handlePaste(e, i) {
    const value = e.clipboardData
      .getData('text/plain')
      .split('.')
      .map((val) => Number(val))
    if (
      value.length === 4 - i &&
      value.every((val) => !isNaN(val) && val >= 0 && val <= 255)
    ) {
      const oldValue = this.state.value
      // @ts-expect-error 9/11/2020
      value.forEach((val, j) => (oldValue[i + j] = val))
      this.setState({ value: oldValue }, () => this.onPropsChange())
      return e.preventDefault()
    }
  }
  /**
   * call change props
   */
  onPropsChange() {
    // @ts-expect-error 9/11/2020
    this.props.onChange(
      this.state.value.map((val) => (isNaN(val) ? '' : val)).join('.')
    )
  }

  render() {
    const className = [
      'react-ip-input',
      // @ts-expect-error 9/11/2020
      this.props.className,
      // @ts-expect-error 9/11/2020
      this.props.isError() ? 'has-error' : ''
    ].join(' ')

    return (
      <div className={className}>
        {this.state.value.map((val, i) => (
          <div className="react-ip-input__item" key={i}>
            <input
              ref={(el) => (this[`_input-${i}`] = el)}
              type="text"
              value={isNaN(val) ? '' : val}
              onChange={(e) => this.handleChange(e, i)}
              onKeyDown={(e) => this.handleKeyDown(e, i)}
              onPaste={(e) => this.handlePaste(e, i)}
            />
            {i !== 3 ? <i>.</i> : false}
          </div>
        ))}
      </div>
    )
  }
}
export default IPut
